export type BookingOrchestrationVariant = 'book-event' | 'book-appointment';

type BookingAnalytics = {
  category: string;
  showLoggedIn: string;
  showLoggedOut: string;
  paymentDropdown: string;
  bookSuccess: string;
  bookError: string;
  includeEventMetadata: boolean;
};

const ANALYTICS: Record<BookingOrchestrationVariant, BookingAnalytics> = {
  'book-event': {
    category: 'source:event',
    showLoggedIn: 'SHOW_BOOK_MODAL_LOGGED_IN',
    showLoggedOut: 'SHOW_BOOK_MODAL_LOGGED_OUT',
    paymentDropdown: 'PAYMENT_OPTIONS_DROPDOWN',
    bookSuccess: 'BOOK_SUCCESS',
    bookError: 'BOOK_ERROR',
    includeEventMetadata: true,
  },
  'book-appointment': {
    category: 'source:appointments',
    showLoggedIn: 'SHOW_BUY_MODAL_LOGGED_IN',
    showLoggedOut: 'SHOW_BUY_MODAL_LOGGED_OUT',
    paymentDropdown: 'PAYMENT_OPTIONS_DROPDOWN',
    bookSuccess: 'BOOK_SUCCESS',
    bookError: 'BOOK_ERROR',
    includeEventMetadata: false,
  },
};

export function isBookAppointment(variant: BookingOrchestrationVariant): boolean {
  return variant === 'book-appointment';
}

export function bookingAnalytics(variant: BookingOrchestrationVariant): BookingAnalytics {
  return ANALYTICS[variant];
}
